// extracted by mini-css-extract-plugin
export default {"listingPriceAndHeart":"ListingPriceAndHeart-module__listingPriceAndHeart___MEGdE","listingPrice":"ListingPriceAndHeart-module__listingPrice___N-1B4"};